import React from 'react';
import { Button } from '@mui/material';

interface PresentActionsProps {
  onFetchVendorDetails: (companyName: string) => void;
  companyName: string;
}

const PresentActions: React.FC<PresentActionsProps> = ({
  onFetchVendorDetails,
  companyName,
}) => {
  return (
    <>
      <Button variant="outlined" disabled size="small">
        Company Already Present
      </Button>
      <Button
        variant="outlined"
        onClick={() => onFetchVendorDetails(companyName)}
        size="small">
        Fetch Vendor Details
      </Button>
    </>
  );
};

export default PresentActions;
